import React from 'react';
import PropTypes from 'prop-types';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  useTheme,
} from '@mui/material/styles';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const ThemeProvider = (props) => {
  const { theme, children } = props;

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <PrivateInnerThemeProvider>{children}</PrivateInnerThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

const PrivateInnerThemeProvider = ({ children }) => {
  const theme = useTheme();

  return <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
};

PrivateInnerThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
